import { TInputProps } from '../controllerTypes';
import './index.scss';
import CloseIcon from '@mui/icons-material/Close';

export const InputController: React.FC<TInputProps> = ({
  error,
  register,
  label,
  placeholder = label && `Enter ${label.toLowerCase()}`,
  type = 'text',
  required,
  autoComplete = 'off',
  toUpperCase,
  clearInput,
  changeHandler,
  inputHeight,
  digitsOnly = false,
  maxDigits,
  ...restProps
}) => {
  const onChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    let value = event.target.value;

    if (digitsOnly) {
      value = value.replace(/\D/g, '');

      if (maxDigits) {
        value = value.slice(0, maxDigits);
      }
    }

    if (toUpperCase) {
      value = value.toUpperCase();
    }

    event.target.value = value;

    changeHandler && changeHandler(event);
    register.onChange(event);
  };

  return (
    <div
      className={`form-field ${restProps.className} ${
        type == 'checkbox'
          ? 'checkbox-field'
          : 'input-field'
      }`}>
      {label && (
        <label className="form-field-label">
          {label}
          {required && <i className="required">*</i>}
        </label>
      )}
      <input
        {...restProps}
        {...register}
        type={digitsOnly ? 'tel' : type}
        inputMode={digitsOnly ? 'numeric' : undefined}
        maxLength={maxDigits}
        style={{
          height: inputHeight ? inputHeight : '50px',
        }}
        placeholder={placeholder}
        className={error ? 'error-input' : ''}
        autoComplete={autoComplete}
        onChange={onChange}
      />
      {clearInput && (
        <button
          onClick={clearInput}
          type="button"
          className="cross-button"
          disabled={restProps.disabled}>
          <CloseIcon fontSize="small" color="warning" />
        </button>
      )}
      <p
        className={`form-field-error ${
          error ? 'visible' : ''
        }`}>
        {error?.toString()}
      </p>
    </div>
  );
};
